module.exports = __webpack_public_path__ + "../resources/img/ic_cloudy_day_weather.b3dabc67.svg";